<template>
    <StandardDropdown
        :modelValue="
            value === 0 || value === 1
                ? {
                      name: bool_options.find((f) => f.key === value).name,
                      key: bool_options.find((f) => f.key === value).key,
                  }
                : null
        "
        :options="bool_options"
        placeholder="Select boolean"
        class="inter-rule-spacing"
        @change="$emit('handleValueChange', $event.value.key)"
    />
</template>

<script>
import StandardDropdown from '@/components/common/StandardDropdown.vue';

export default {
    name: 'BoolRule',
    props: ['value'],
    components: { StandardDropdown },
    data() {
        return {
            bool_options: [
                { name: 'True', key: 1 },
                { name: 'False', key: 0 },
            ],
        };
    },
};
</script>

<style scoped></style>
